import { render, staticRenderFns } from "./batchBindAppByRoleIdsDialog.vue?vue&type=template&id=42796126&"
import script from "./batchBindAppByRoleIdsDialog.vue?vue&type=script&lang=js&"
export * from "./batchBindAppByRoleIdsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports